var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancelled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#CED7DF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.33334C8.31331 5.33334 5.33331 8.31334 5.33331 12C5.33331 15.6867 8.31331 18.6667 12 18.6667C15.6866 18.6667 18.6666 15.6867 18.6666 12C18.6666 8.31334 15.6866 5.33334 12 5.33334ZM12 17.3333C9.05998 17.3333 6.66665 14.94 6.66665 12C6.66665 9.06001 9.05998 6.66668 12 6.66668C14.94 6.66668 17.3333 9.06001 17.3333 12C17.3333 14.94 14.94 17.3333 12 17.3333ZM14.3933 8.66668L12 11.06L9.60665 8.66668L8.66665 9.60668L11.06 12L8.66665 14.3933L9.60665 15.3333L12 12.94L14.3933 15.3333L15.3333 14.3933L12.94 12L15.3333 9.60668L14.3933 8.66668Z",
    fill: "#FBFBFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelled);
export default __webpack_public_path__ + "static/media/cancelled.434fe8666cbd5a5ffa85115db40e884e.svg";
export { ForwardRef as ReactComponent };